import { useCallback, useState } from 'react';
import {
    CATEGORY_MARKETING,
    CATEGORY_NECESSARY,
    CATEGORY_STATISTICS,
} from '../config/constants';
import addAllCategoriesConsent from '../service/addAllCategoriesConsent';
import addNecessaryCategoriesConsent from '../service/addNecessaryCategoriesConsent';
import addSelectedCategoriesConsent from '../service/addSelectedCategoriesConsent';
import hasCookieCategoryConsent from '../service/hasCookieCategoryConsent';

function useCookieConsentChoices(closeBanner) {
    const [checkboxValues, setCheckboxValues] = useState(() => ({
        [CATEGORY_NECESSARY]: true,
        [CATEGORY_STATISTICS]: hasCookieCategoryConsent(CATEGORY_STATISTICS),
        [CATEGORY_MARKETING]: hasCookieCategoryConsent(CATEGORY_MARKETING),
    }));

    const handleCheckboxChange = useCallback((event) => {
        const { name, checked } = event.target;
        setCheckboxValues(previous => (
            previous[name] === undefined ? previous : { ...previous, [name]: checked }
        ));
    }, []);

    const acceptRecommended = useCallback(() => {
        addAllCategoriesConsent();
        closeBanner();
    }, [closeBanner]);

    const acceptOnlyNecessary = useCallback(() => {
        addNecessaryCategoriesConsent();
        closeBanner();
    }, [closeBanner]);

    const acceptSelected = useCallback(() => {
        const categories = Object.entries(checkboxValues)
            .filter(([, checked]) => checked)
            .map(([categoryKey]) => categoryKey);

        addSelectedCategoriesConsent(categories);
        closeBanner();
    }, [checkboxValues, closeBanner]);

    return {
        checkboxValues,
        handleCheckboxChange,
        acceptRecommended,
        acceptOnlyNecessary,
        acceptSelected,
    };
}

export default useCookieConsentChoices;
